import DepartmentListPage from './list/'
import DepartmentAddPage from './add/'
import DepartmentViewPage from './view/'

export default {
  DepartmentListPage,
  DepartmentViewPage,
  DepartmentAddPage
}
